(() => {
  const syncStickyAtc = (bar, sourceBar) => {
    const destinationTitle = bar.querySelector('.bl-mobile-sticky-atc__title');
    const sourceTitle = sourceBar.querySelector('.bl-mobile-sticky-atc__title');
    const destinationPrice = bar.querySelector('.bl-mobile-sticky-atc__price');
    const sourcePrice = sourceBar.querySelector('.bl-mobile-sticky-atc__price');
    const destinationButton = bar.querySelector('.bl-mobile-sticky-atc__button');
    const sourceButton = sourceBar.querySelector('.bl-mobile-sticky-atc__button');

    if (destinationTitle && sourceTitle) destinationTitle.textContent = sourceTitle.textContent;
    if (destinationPrice && sourcePrice) destinationPrice.textContent = sourcePrice.textContent;

    if (destinationButton && sourceButton) {
      destinationButton.innerHTML = sourceButton.innerHTML;
      destinationButton.disabled = sourceButton.disabled;
    }
  };

  const initializeStickyAtc = (root = document) => {
    const bars = root.querySelectorAll ? root.querySelectorAll('[data-bl-sticky-atc]') : [];

    bars.forEach((bar) => {
      if (bar.dataset.blStickyInitialized === 'true') return;

      const mainButton = document.getElementById(bar.dataset.mainButtonId);
      if (!mainButton) return;

      bar.dataset.blStickyInitialized = 'true';

      const observer = new IntersectionObserver(
        ([entry]) => {
          const shouldShow = !entry.isIntersecting && window.scrollY > 160;
          bar.classList.toggle('is-visible', shouldShow);
        },
        { threshold: 0.2 }
      );

      observer.observe(mainButton);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        const sectionId = bar.id.replace('BeadLeavesStickyAtc-', '');
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (String(event.data.sectionId) !== sectionId) return;

          const sourceBar = event.data.html.getElementById(bar.id)
            || event.data.html.querySelector('[data-bl-sticky-atc]');
          if (sourceBar) syncStickyAtc(bar, sourceBar);
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeStickyAtc());
  } else {
    initializeStickyAtc();
  }

  document.addEventListener('shopify:section:load', (event) => initializeStickyAtc(event.target));

  const productObserver = new MutationObserver(() => initializeStickyAtc());
  productObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
